export default __webpack_public_path__ + "static/media/back.878a73bc.png";